/**
 * @generated SignedSource<<bbea8755aa42a37c0c394cf02d58bb5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary$data = {
  readonly total: number;
  readonly " $fragmentType": "WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary";
};
export type WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary$key = {
  readonly " $data"?: WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "total",
      "storageKey": null
    }
  ],
  "type": "IntegrationTurnpikeSummary",
  "abstractKey": null
};

(node as any).hash = "613471399cef0fb65e6f406e72187b6c";

export default node;
